export enum passwordResetTypes {
  FETCH_PASSWORD_RESET_REQUEST = "FETCH_PASSWORD_RESET_REQUEST",
  FETCH_PASSWORD_RESET_SUCCESS = "FETCH_PASSWORD_RESET_SUCCESS",
  FETCH_PASSWORD_RESET_FAILURE = "FETCH_PASSWORD_RESET_FAILURE",
}